import React from "react";
import { Button, Checkbox } from "antd";
import icon from "../../../assets/paper.png";
import { useNavigate } from "react-router-dom";

const Statuscard = ({ title, description, path, status = "Complete" }) => {
  const navigate = useNavigate();
  return (
    <div className="md:h-60 h-48 bg-[#F2FAD6] border border-[#DBEBA2] rounded-xl md:p-5 p-3 md:px-8 px-4 flex flex-col justify-between">
      <CompletionStatus
        className=""
        status={status}
      />
      <div className="flex items-center">
        <Checkbox className="db-check rounded w-5 h-5 mr-3 bg-[#5A741D66]" />
        <p className="font-bold app-text md:text-xl text-base">{title}</p>
      </div>
      <p className="font-light app-text text-base">{description}</p>
      <Button
        shape="round"
        className="flex items-center bg-[#C2D18C] hover:bg-[#C2D18C80] focus:bg-[#C2D18C] border-0 px-5 font-bold text-base app-text-2 hover:text-[#5A741D80] w-max"
        onClick={() => navigate(path)}
      >
        {status === "Incomplete" ? "Fill" : "Review"}
        <img
          className="w-6 ml-3"
          src={icon}
          alt=""
        />
      </Button>
    </div>
  );
};

export default Statuscard;

const CompletionStatus = ({ status, className }) => {
  return (
    <div
      className={
        "text-[#5A741D] md:p-2 p-1 md:px-3 px-2 rounded-2xl text-sm border border-[#DBEBA2] w-max shadow-sm " +
        className
      }
    >
      {status}
    </div>
  );
};
